<template>
  <div class="fiche-biblio">
    <v-expansion-panel expand>
      <v-expansion-panel-content v-for="biblio in biblios" :key="biblio.id">
        <div slot="header">
          <v-icon color="primary">collections_bookmark</v-icon>
          {{ biblio.title }}
          <span class="caption grey--text text--darken-1">
            (
            {{ $tc('subLibraries', biblio.subs.length, { count: biblio.subs.length }) }}
            {{ $tc('sentences', biblio.sentences.length, { count: biblio.sentences.length }) }}
            )
          </span>
        </div>
        <!-- SOUS-BIBLIOTHÈQUES -->
        <v-card>
          <v-card-text class="grey lighten-3 px-1">
            <v-expansion-panel v-if="biblio.subs.length" expand>
              <v-expansion-panel-content v-for="sub in biblio.subs" avatar :key="sub.id">
                <div slot="header">
                  <v-icon color="primary">book</v-icon>
                  {{sub.title}}
                  <span class="caption grey--text text--darken-1">
                    ({{ $tc('sentences', sub.sentences.length, {count: sub.sentences.length}) }})
                  </span>
                </div>
                <!-- PHRASES DE LA SOUS-BIBLIOTHÈQUE -->
                <v-card>
                  <v-card-text class="grey lighten-3 pl-1 pr-2">
                    <v-list v-if="sub.sentences.length" two-line dense subheader>
                      <v-list-tile
                        v-for="phrase in sub.sentences"
                        :key="phrase.id"
                        @click="status === 'offline' ? ';' : putMessage(phrase.title)"
                      >
                        <v-list-tile-content>
                          {{ phrase.title | truncate(120) }}
                        </v-list-tile-content>
                        <v-list-tile-action>
                          <v-btn
                            v-if="checkRouteSendChat"
                            @click="sendMessage(phrase.title)"
                            @mouseover="overMenu = true"
                            @mouseleave="overMenu = false"
                            :color="'secondary--text'"
                            icon
                            small
                          >
                            <v-icon>send</v-icon>
                          </v-btn>
                          <v-btn
                            v-else
                            @click="sendMessage(phrase.title)"
                            @mouseover="overMenu = true"
                            @mouseleave="overMenu = false"
                            :color="status === 'offline' ? 'grey--text' : 'secondary--text'"
                            icon
                            small
                          >
                            <v-icon>send</v-icon>
                          </v-btn>
                        </v-list-tile-action>
                      </v-list-tile>
                    </v-list>
                  </v-card-text>
                </v-card>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-card-text>
        </v-card>
        <!-- PHRASES DE LA BIBLIOTHÈQUE -->
        <v-card>
          <v-card-text class="grey lighten-3 px-1">
            <v-list v-if="biblio.sentences.length" two-line dense subheader>
              <v-list-tile
                v-for="phrase in biblio.sentences"
                :key="phrase.id"
                @click="status === 'offline' ? ';' : putMessage(phrase.title)"
              >
                <v-list-tile-content>
                  {{ phrase.title | truncate(120) }}
                </v-list-tile-content>
                <v-list-tile-action>
                  
                  <v-btn
                    v-if="checkRouteSendChat"
                    @click="sendMessage(phrase.title)"
                    @mouseover="overMenu = true"
                    @mouseleave="overMenu = false"
                    :color="'secondary--text'"
                    icon
                    small
                  >
                    <v-icon>send</v-icon>
                  </v-btn>
                  <v-btn
                    v-else
                    @click="sendMessage(phrase.title)"
                    @mouseover="overMenu = true"
                    @mouseleave="overMenu = false"
                    :color="status === 'offline' ? 'grey--text' : 'secondary--text'"
                    icon
                    small
                  >
                    <v-icon>send</v-icon>
                  </v-btn>
                </v-list-tile-action>
              </v-list-tile>
            </v-list>
          </v-card-text>
        </v-card>
      </v-expansion-panel-content>
    </v-expansion-panel>
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  data () {
    return {
      overMenu: false
    }
  },

  computed: {
    ...mapState('_StoreWatcheeBox', ['status']),
    ...mapState('_Biblios', ['biblios']),
    // check sur quelle route ce trouve l'agent
    // car il est possible d'envoyer un message sur les route 'attente' et 'contact' même en status 'offline'
    checkRouteSendChat () {
      if (this.$route.fullPath === '/trafic/attente' || this.$route.fullPath === '/trafic/contact' || this.directChat) {
        return true
      } else {
        return false
      }
    }
  },

  methods: {
    putMessage (msg) {
      if (this.overMenu) return
      this.$emit('put', msg)
    },
    sendMessage (msg) {
      if (this.$route.fullPath === '/trafic/attente' || this.$route.fullPath === '/trafic/contact' || this.directChat) {
        // envois un message mùême offline sur ces pages
        this.$emit('send', { message: msg })
      } else {
        // sur les autres pages, pas d'envois de message offline
        if (this.status === 'offline') {
          this.$store.dispatch('_Notifier/NEW_NOTIF', {
            message: this.$t('currentlyOffline'),
            context: 'error'
          })
          return
        }
        // sinon 'online' ou 'busy' envois message
        this.$emit('send', { message: msg })
      }
    }
  }
}
</script>

<style>
.fiche-biblio {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/watcheebox/WzFicheBiblioPhrases.vue